import { makeAutoObservable } from 'mobx';
import {endpoints, types} from 'main/tools';
import {DomainStore} from 'shared/store';
import {CompanyDocument, AssignmentRule} from 'main/stores/documents';
import {TaxFormTemplate} from 'main/stores/tax_form_templates';

/*global window*/

class TaxFormTemplateEditState {
  store = new DomainStore();
  match;

  taxFormTemplate;
  companyDocument;
  errors = {};

  constructor() {
    makeAutoObservable(this, {
      store: false
    });
  }

  receiveProps({match}) {
    this.match = match;
  }

  async load() {
    await this.store._compose([
      endpoints.TAX_FORM_TEMPLATE.with(this.match.params.id)
    ]);

    this.taxFormTemplate = new TaxFormTemplate(
      this.store._getSingle(types.TAX_FORM_TEMPLATE)
    );
    this.companyDocument = new CompanyDocument({
      documentType: 'pdf_template',
      name: this.taxFormTemplate.fileName,
      locale: this.taxFormTemplate.locale,
      annotations: this.taxFormTemplate.annotations,
      assignmentRules: [new AssignmentRule({assigneeType: 'employee', order: 0})]
    });
  }

  async saveAnnotations(annotations) {
    this.taxFormTemplate.annotations = annotations;

    const {model, errors} = await this.store.patch(this.taxFormTemplate);
    this.errors = errors;

    if (model) {
      this.backToIndex();
    }
  }

  backToIndex() {
    window.location = this.taxFormTemplate.link('adminIndex');
  }

  get pdfUrl() {
    return this.taxFormTemplate.link('url');
  }
}

export default TaxFormTemplateEditState;
